import { ServiceWorkerModule } from '@angular/service-worker';

// Modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from '../modules/shared/shared.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HomeModule } from 'src/modules/home/home.module';
import { BsModalService, ModalModule, BsModalRef } from 'ngx-bootstrap';


// Components
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';


// Services
import { Globals } from '../Globals';

import { CommonService } from 'src/modules/shared/services/common.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';


import { retry } from 'rxjs/operators';

//Guards
import { IsEligibleForSubmitGuard } from 'src/modules/shared/guards/is-eligible-for-submit.guard';
import { HavePermissionToAccessComponentGuard } from 'src/modules/shared/guards/have-permission-to-access-component.guard';
import { IsLoggedInGuard } from 'src/modules/shared/guards/is-logged-in.guard';
import { IsValidUrlGuard } from 'src/modules/shared/guards/is-valid-url.guard';
import { UnauthorizedModule } from 'src/modules/unauthorized/unauthorized.module';
import { LoginModule } from 'src/modules/login/login.module';
import { ErrorModule } from 'src/modules/error/error.module';
import { NotfoundpageModule } from 'src/modules/notfoundpage/notfoundpage.module';
// import { BnNgIdleService } from 'bn-ng-idle';
// import { BnNgIdleService } from 'bn-ng-idle';
import { environment } from '../environments/environment';
import { ContactUsModule } from 'src/modules/Contact-us/Contact-us.module';
import { ComingSoonModule } from 'src/modules/Coming-soon/Coming-soon.module';
// import { BnNgIdleService } from 'bn-ng-idle';
// import { BnNgIdleService } from 'bn-ng-idle';

import { CookieService } from 'ngx-cookie-service';
import { IsAuthenticatedGuard } from 'src/modules/shared/guards/is-authenticated.guard';
import { IsProfileOwnerGuard } from 'src/modules/shared/guards/is-profile-owner.guard';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NewsModule } from 'src/modules/News/news.module';
import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';  
import localeAr from '@angular/common/locales/ar';  

//registerLocaleData
registerLocaleData(localeAr);  // Register Arabic locale  

const dbConfig: DBConfig  = {
  name: 'MyDb',
  version: 1,
  objectStoresMeta: [{
    store: 'userLoginsDB',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'Type', keypath: 'Type', options: { unique: false } },
      { name: 'CPR', keypath: 'CPR', options: { unique: false } },
      { name: 'CR', keypath: 'CR', options: { unique: false } },
      { name: 'ChoosenModule', keypath: 'ChoosenModule', options: { unique: false } },
    ]
  }
]
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.LoadAppConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    CarouselModule,
    BrowserAnimationsModule,
    SharedModule.forRoot(),
    HomeModule,
    //NewsModule,
    LoginModule,
    ErrorModule,
    UnauthorizedModule,
    NotfoundpageModule,
    NgIdleKeepaliveModule.forRoot(),
    ModalModule.forRoot(),
   // LeaseInModule,
    // HomeModule,
    //Routing Modules
    ModalModule.forRoot(),
    AppRoutingModule,
   ContactUsModule,
    ComingSoonModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    TranslateModule.forRoot(
      {
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient]
        }
      }
    ),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),

  ],
  providers: [
    DatePipe,
    Globals,
    HavePermissionToAccessComponentGuard,
    TranslateService,
    IsEligibleForSubmitGuard,
    IsLoggedInGuard,
    IsValidUrlGuard,
    IsAuthenticatedGuard,
    IsProfileOwnerGuard,
    BsModalService,
    BsModalRef,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService,]
    },
    CommonService,
    CookieService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
